// HPP: Swatch King leaves Size unpicked (see the inline script in product-variant-picker.liquid) and
// holds Add to cart, but a colour tap makes the theme re-enable the button while the store still has
// the first size in hand. Keep the button held, reading "Select a Size", until a size is actually picked.
// Reads the page only; variant, swatch and cart code untouched.
(() => {
  if (window.hppSizeGuard) return;
  window.hppSizeGuard = true;

  const BUTTON_TEXT = 'Select a Size';

  const setup = (productInfo) => {
    const sizeInput = Array.from(productInfo.querySelectorAll('input[type="radio"]')).find((input) =>
      /^size-\d+/i.test(input.name)
    );
    if (!sizeInput) return;
    const optionKey = `option${sizeInput.name.match(/-(\d+)/)[1]}`;

    const sizeSwatches = () =>
      Array.from(document.querySelectorAll(`[swatch-option="${optionKey}"]`))
        .map((swatch) => swatch.closest('li[role="radio"]'))
        .filter(Boolean);
    const sizeChosen = () => sizeSwatches().some((item) => item.getAttribute('aria-checked') === 'true');

    const holdButton = () => {
      // Only act once Swatch King has drawn the size buttons; without them the theme's own buttons show S.
      if (sizeSwatches().length < 2 || sizeChosen()) return;
      const button = productInfo.querySelector('product-form button[type="submit"]');
      if (!button) return;
      if (!button.hasAttribute('disabled')) button.setAttribute('disabled', 'disabled');
      const label = button.querySelector('span');
      if (label && label.textContent.trim() !== BUTTON_TEXT && !/sold out/i.test(label.textContent)) {
        label.textContent = BUTTON_TEXT;
      }
    };

    new MutationObserver(holdButton).observe(productInfo, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-checked'],
    });
    holdButton();
  };

  const init = () => document.querySelectorAll('product-info').forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
